module.exports = __webpack_public_path__ + "c0d0c4e3792466afa2642951b6e98e4a.jpg";